import React from 'react';
import styled from 'styled-components';
import { Home } from '@mui/icons-material';
import { useParams } from 'react-router-dom';
import {
  ViewSituation,
  PanelApplications,
  defaultAppliedFilter,
} from '../Assessment';
import { Alert, Button, Loading } from '../../components';
import { PANEL_HOME_PAGE_TEXT } from './lang';
import { useGetPanelApplications } from '../Assessment/graphql';
import { useAuth } from '../../contexts';

export const PanelDetailReviewVersion: React.FunctionComponent = () => {
  const { panelId = '' } = useParams();
  const { handleLoading } = useAuth();

  const {
    panelApplications,
    panelInformation,
    panelNumbers,
    dimensionsCollection,
    allocationReleased,
    hasAllocatedReviewers,
    lockFilterControllers: { filterLockedFlag },
    loading,
    error,
    refetch,
  } = useGetPanelApplications({ panelId, onlyReviewee: true });

  const handleBack = (): void => {
    window.location.href = `/internal/panel-homepage`;
  };

  if (error) {
    return (
      <Alert
        openAlert
        setOpenAlert={() => {}}
        alertDetails={{
          alertContent: `Error Occurs.` + (error as Error)?.message,
          alertType: 'error',
        }}
      />
    );
  }
  return (
    <PageContainer>
      {loading ? (
        <Loading />
      ) : (
        <>
          <div className="p-4">
            <Button
              variant="outlined"
              onClick={handleBack}
              size="medium"
              startIcon={<Home />}
              sx={{
                textTransform: 'none',
              }}
            >
              {PANEL_HOME_PAGE_TEXT.HOME_PAGE}
            </Button>
            <h1>{PANEL_HOME_PAGE_TEXT.APPLICATION_REVIEW}</h1>
          </div>
          <div className="form-area">
            <PanelApplications
              viewSituation={ViewSituation.MEMBER_REVIEWEE_ONLY}
              panelId={panelId}
              allocationReleased={allocationReleased}
              hasAllocatedReviewers={hasAllocatedReviewers}
              panelApplications={panelApplications}
              panelNumbers={panelNumbers}
              panelInformation={panelInformation}
              filterLockedFlag={filterLockedFlag}
              dimensionsCollection={dimensionsCollection}
              handleLoading={handleLoading}
              refetch={refetch}
              // the following props are not in use for panel detail review versions
              dualPartnerUniversityList={[]}
              appliedFilter={defaultAppliedFilter}
              handleApplyTagFilter={() => {}}
              handleManageAlert={() => {}}
            />
          </div>
        </>
      )}
    </PageContainer>
  );
};

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;

  h1 {
    font-size: 1.5rem;
    font-weight: 700;
    margin-bottom: 1.5rem;
    text-align: center;
    color: #951d1d;
  }

  .form-area {
    flex: 0.95;
    margin: 1rem;
  }
`;
